import React, {Fragment} from 'react';
import Component from 'components/component';
import Image from 'components/image/index.js';
import VideoPlayer from 'components/video-player';
import {ViewStatus} from 'pages/content/lives/live-status';
import {formatDuration} from 'helpers/date';
import {DI} from 'modules';

import './style.css';

export class ViewVideoPlayer extends Component {
  static defaultProps = {
    entity: {},
    isLive: false,
    isOnLive: false,
    time: '',
  };

  state = {
    showStopButton: false,
    playing: false,
  };

  componentWillUnmount() {
    clearTimeout(this.timeout);
  }

  playPause = () => this.setState(prev => ({playing: !prev.playing}));

  onMouseLeave = () => this.setState({showStopButton: false});

  onMouseMove = () => {
    clearTimeout(this.timeout);

    this.setState({
      showStopButton: true,
    });

    this.timeout = setTimeout(this.onMouseLeave, 3000);
  };

  componentDidMount() {
    this.playPause();
    setTimeout(this.playPause, 20);
  }

  render() {
    const {entity, isLive, className, isOnLive, time} = this.props;
    // const strings = this.props.common.strings;
    const isHls = this.previewUrl && this.previewUrl.includes('m3u8');
    const videoJsOptions = {
      autoplay: true,
      controls: true,
      sources: [
        {
          src: this.previewUrl,
          type:
            isLive || isHls ? 'application/x-mpegURL' : 'video/mp4',
        },
      ],
      key: this.previewUrl,
      watermark: this.props.watermark,
      format: entity.format,
      className: `live__img live__img--${entity.status}`,
      style: {userSelect: 'none'},
    };

    const showDuration = Boolean(
      !this.state.playing && !isLive && entity.duration,
    );

    const showPlayPauseControl = Boolean(
      this.state.playing ? this.state.showStopButton : this.previewUrl,
    );

    return (
      <div
        className={this.classList(
          'live-image',
          className,
          isLive ? 'is-live' : 'is-vidio',
        )}
        onMouseMove={this.onMouseMove}
        onMouseLeave={this.onMouseLeave}
      >
        <div className='live-img'>
          {this.state.playing &&
          entity.downloadable !== 'retracted' ? (
            <VideoPlayer {...videoJsOptions} />
          ) : (
            <Image
              url={this.props.preview}
              title={entity.title}
              render={({url}) => (
                <Fragment>
                                    <span
                                      className={`live__img`}
                                    >
                                        <img src={url} alt={entity.title} />
                                    </span>
                  {/* {entity.limit_type === 'pool' && (
                                        <Tooltip content={strings['page.video.left.pool.info']}>
                                            <span className="live__mark">{`Pool ${strings['page.lives.view.pool_description']}`}</span>
                                        </Tooltip>
                                    )} */}
                </Fragment>
              )}
            />
          )}
          {isLive && (
            <ViewStatus
              status={entity.status}
              tbc={entity.start_at_not_finalized}
              live={entity}
              isOnLive={isOnLive}
              time={time}
            />
          )}
          {showDuration && (
            <DurationVideo duration={entity.duration} />
          )}
          {showPlayPauseControl &&
            entity.downloadable !== 'retracted' && (
              <span
                onClick={this.playPause}
                className={this.classList(
                  'live__play',
                  this.state.playing && '_stop',
                )}
                style={{cursor: 'pointer'}}
              />
            )}
        </div>
      </div>
    );
  }

  get previewUrl() {
    const {entity, isLive} = this.props;

    if (!isLive) return entity.preview_url;

    const allowStatus = ['next', 'live'];
    const lang =
      entity.languages.find(
        (lang) => lang.id === this.props.selectedLanguageID,
      ) ||
      entity.languages[0] ||
      {};

    if (allowStatus.includes(entity.status) && lang.preview_target) {
      return lang.preview_target.hls_playback_url;
    } else {
      return null;
    }
  }
}

function DurationVideo({duration}) {
  return <span className='live__duration'>{formatDuration(duration)}</span>;
}

export default DI(['common'])(ViewVideoPlayer);
